import { render, staticRenderFns } from "./IconColorSwatch.vue?vue&type=template&id=37952d99&"
import script from "./IconColorSwatch.vue?vue&type=script&lang=js&"
export * from "./IconColorSwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports